import { subscribe } from 'shared/store'
import { INIT_CROSSSELL } from 'shared/store/ducks/events'
import mountSellerModalContainer from 'views/containers/browser/SellerModalContainer/mountSellerModalContainer'

export default () => {
  subscribe.after(INIT_CROSSSELL, () => {
    mountSellerModalContainer()
  })
}
